const ADMIN_KPI_ILLUSTRATIONS: Record<string, string> = {
  users: 'admin.kpi.users',
  active: 'admin.kpi.active',
  results: 'admin.kpi.results',
  opportunities: 'admin.kpi.opportunities',
  cms: 'admin.kpi.cms',
  tickets: 'admin.kpi.tickets',
  storage: 'admin.kpi.storage',
  ai: 'admin.kpi.ai',
  revenue: 'admin.kpi.revenue',
};

const ADMIN_MODULE_ILLUSTRATIONS: Record<string, string> = {
  Users: 'admin.module.users',
  Results: 'admin.module.results',
  Opportunities: 'admin.module.opportunities',
  Media: 'admin.module.media',
  Notifications: 'admin.module.notifications',
  SEO: 'admin.module.seo',
  CMS: 'admin.module.cms',
  Support: 'admin.module.support',
};

export function adminKpiIllustration(kpiId: string): string {
  return ADMIN_KPI_ILLUSTRATIONS[kpiId] ?? 'admin.kpi.default';
}

export function adminModuleIllustration(label: string): string {
  return ADMIN_MODULE_ILLUSTRATIONS[label] ?? 'admin.kpi.default';
}

const ADMIN_DETAIL_ILLUSTRATIONS: Record<string, string> = {
  user: 'admin.kpi.users',
  permission: 'admin.panel.security',
  super_admin: 'admin.panel.security',
  admin: 'admin.module.users',
  cms: 'admin.module.cms',
  editor: 'admin.module.media',
  student: 'page.home',
};

export function adminRoleIllustration(roleId: string): string {
  return ADMIN_DETAIL_ILLUSTRATIONS[roleId] ?? 'admin.module.users';
}

export function adminDetailIllustration(kind: 'user' | 'permission'): string {
  return ADMIN_DETAIL_ILLUSTRATIONS[kind];
}

export const ADMIN_PANEL_ILLUSTRATIONS = {
  analytics: 'admin.panel.analytics',
  health: 'admin.panel.health',
  approvals: 'admin.panel.approvals',
  activity: 'admin.panel.activity',
  revenue: 'admin.panel.revenue',
  api: 'admin.panel.api',
  database: 'admin.panel.database',
  security: 'admin.panel.security',
  logs: 'admin.panel.logs',
  ai: 'admin.panel.ai',
  support: 'admin.panel.support',
  notifications: 'admin.panel.notifications',
  audit: 'admin.panel.audit',
  schedule: 'admin.panel.schedule',
} as const;
